// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__279Vo","right":"styles_right__2F5Kh"};